import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMessageApi } from "../../../../provider/AntdNotification";
import React, { useMemo } from "react";
import {
  useAuthorDelete,
  useAuthorList,
} from "../../../../hooks/api/author/hook";
import { IAuthorPayload } from "../../../../types/api/author";
import ButtonWrapper from "../../../../views/components/reuseComp/ButtonWrapper";
import AuthorForm from "./AuthorForm";
import AuthorTable from "./AuthorTable";

const AuthorComp: React.FC<{ allowURLStateUpdate?: boolean }> = ({
  allowURLStateUpdate = true,
}) => {
  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };
  const message = useMessageApi();

  const navigate = useNavigate();
  const location = useLocation();
  const isCreatePage = location.pathname === "/website/blog/create";

  const { id } = useParams<{ id: string }>();
  const isEditPage = !!id;

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useAuthorList({
    page: 1,
    limit: 20,
    ...DEFAULT_NUQS_CONFIG,
  });

  const qData = data?.qData ?? { page: 1, limit: 20 };
  const { mutate: deleteAuthor } = useAuthorDelete({ qData });

  const authorlist: IAuthorPayload[] = useMemo(() => data?.data || [], [data]);

   const handleDelete = (id: string) => {
      deleteAuthor(
        { ids: id },
        {
          onSuccess: () => {
            message.success("Author deleted successfully");
          },
          onError: (err: any) => {
            const msg =
              err?.response?.data?.message ||
              err?.message ||
              "Failed to delete author";

            message.error(msg);
          },
        }
      );
      };


  return (
    <div className="mb-6">
    <div className=" flex justify-between items-caenter">
        <h1 className="text-xl sm:text-3xl  sm:mb-2">
          {isCreatePage ? "Create Author" : "Form Author"}
        </h1>

        {(!isCreatePage && !isEditPage) && (
          <ButtonWrapper
            className="bg-primary text-white"
            onClick={() => navigate("/website/blog/create")}
          >
            Create Author
          </ButtonWrapper>
        )}
      </div>
       <div className="mt-5">
        {(isCreatePage || isEditPage) ? (
          <AuthorForm qData={qData} id={id}/>
        ) : (
          <AuthorTable
            data={authorlist}
            {...{  loading: isFetching, refetch, qData, DEFAULT_NUQS_CONFIG,handleDelete }}
          />
        )}
      </div>
    </div>
  )
};

export default AuthorComp;
